import { render, staticRenderFns } from "./addAirCleanAlarmDialog.vue?vue&type=template&id=23b494a7&scoped=true"
import script from "./addAirCleanAlarmDialog.vue?vue&type=script&lang=js"
export * from "./addAirCleanAlarmDialog.vue?vue&type=script&lang=js"
import style0 from "./addAirCleanAlarmDialog.vue?vue&type=style&index=0&id=23b494a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b494a7",
  null
  
)

export default component.exports